export enum PostNewCashInvoiceStatus {
    InActive = 0,
    Issue = 1,
    Manual = 2
}